import { Flex, HStack, Skeleton, SkeletonCircle } from "@chakra-ui/react";

const TraderDetails = () => (
    <HStack>
        <SkeletonCircle flexShrink={0} size="5" />
        <Flex direction="column">
            <Skeleton w="167px" h={2} mt={0.5} mb={1} />
            <Skeleton w="153px" h={2} />
        </Flex>
        <Skeleton w="67px" h={3} mt={0.5} mb={1} />
    </HStack>
);

const Template = () => (
    <Flex direction="column">
        <Flex mb={4} flexGrow={1} overflow="hidden">
            <Flex direction="column" width="100%">
                <Skeleton alignSelf="flex-start" w="80px" h={3} mt={0.5} mb={1} />
                <Flex justifyContent="space-between" flexFlow={["column", "row"]} gap={[3, 0]}>
                    <TraderDetails />
                    <TraderDetails />
                </Flex>
            </Flex>
        </Flex>
        <Skeleton alignSelf="flex-end" w="124px" h={3} mt={0.5} mb={1} />
    </Flex>
);

export const LoadingSkeleton = () => {
    return (
        <Flex direction="column">
            <Template />
            <Template />
            <Template />
        </Flex>
    );
};
